// activation_return_link: helpers for carrying the boat's `return_to` link
// through the auth round-trip.
//
// `return_to` is the boat's own LAN origin (e.g. http://10.3.0.162:1880),
// passed by Neomaris Core's first-run UI so the Activate success page can render a
// "Return to your boat" button. It is a CROSS-ORIGIN ABSOLUTE URL we cannot
// allowlist by host, and it is ONLY ever rendered as a link the user clicks —
// never navigated to programmatically. The client guard mirrors the server's
// validateReturnTo: http(s) only (blocks javascript:/data:/file:), no embedded
// credentials. Returns the normalized URL or null.

export function safeReturnTo(value: string | null | undefined): string | null {
  if (typeof value !== 'string' || value.length === 0) return null;
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return null;
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
  if (url.username.length > 0 || url.password.length > 0) return null;
  return url.toString();
}

// Merge a validated `return_to` into a root-relative destination's query so it
// survives a `navigate(dest)` (router state can't ride a full-page redirect;
// the query can). No-op when `returnTo` is null.
export function withReturnTo(dest: string, returnTo: string | null): string {
  if (returnTo === null) return dest;
  const sep = dest.includes('?') ? '&' : '?';
  return `${dest}${sep}return_to=${encodeURIComponent(returnTo)}`;
}
